/**
 * Copied from escribonauta-projects/services/project-analysis/engine/analysis-engine.config.ts
 * (main a3d431d): ANALYSIS_ENGINE_CONFIG.spanishStopwords and .speechVerbs.
 * Accented duplicates are kept as in the engine; normalizeWritingWord collapses them at use.
 *
 * Shared with writing-habits capture (do not duplicate).
 * TODO(future): extract this lexicon to escribonauta-setup (same pattern as the
 * layout engine) so web and projects cannot drift.
 */

export const WRITING_ALERT_STOPWORDS: readonly string[] = [
  'a',
  'al',
  'algo',
  'algunas',
  'algunos',
  'ante',
  'antes',
  'como',
  'con',
  'contra',
  'cual',
  'cuando',
  'de',
  'del',
  'desde',
  'donde',
  'durante',
  'e',
  'el',
  'ella',
  'ellas',
  'ellos',
  'en',
  'entre',
  'era',
  'eras',
  'es',
  'esa',
  'esas',
  'ese',
  'eso',
  'esos',
  'esta',
  'estas',
  'este',
  'esto',
  'estos',
  'fue',
  'fueron',
  'ha',
  'haber',
  'habia',
  'han',
  'has',
  'hasta',
  'hay',
  'he',
  'la',
  'las',
  'le',
  'les',
  'lo',
  'los',
  'me',
  'mi',
  'mis',
  'mucho',
  'muy',
  'ni',
  'no',
  'nos',
  'nosotros',
  'o',
  'os',
  'otra',
  'otras',
  'otro',
  'otros',
  'para',
  'pero',
  'poco',
  'por',
  'porque',
  'que',
  'quien',
  'se',
  'sea',
  'según',
  'si',
  'sido',
  'sin',
  'sobre',
  'sois',
  'somos',
  'son',
  'su',
  'sus',
  'tambien',
  'también',
  'te',
  'tiene',
  'tienen',
  'todo',
  'todos',
  'tu',
  'tus',
  'un',
  'una',
  'unas',
  'uno',
  'unos',
  'vosotros',
  'y',
  'ya',
  'yo',
]

export const WRITING_ALERT_SPEECH_VERBS: readonly string[] = [
  'dijo',
  'dice',
  'decia',
  'decía',
  'dira',
  'dirá',
  'respondio',
  'respondió',
  'responde',
  'pregunto',
  'preguntó',
  'pregunta',
  'exclamo',
  'exclamó',
  'exclamaba',
  'susurro',
  'susurró',
  'susurraba',
  'grito',
  'gritó',
  'gritaba',
  'murmuro',
  'murmuró',
  'murmuraba',
  'contesto',
  'contestó',
  'contesta',
  'anadio',
  'añadio',
  'añadió',
  'comento',
  'comentó',
  'afirmo',
  'afirmó',
  'nego',
  'negó',
  'explico',
  'explicó',
  'aseguro',
  'aseguró',
  'advirtio',
  'advirtió',
  'ordeno',
  'ordenó',
  'pidio',
  'pidió',
  'reclamo',
  'reclamó',
  'insistio',
  'insistió',
]
